import styled from 'styled-components';
import { media, space, rems, getSectionGradient } from '../../ui/helpers';
import { colors } from '../../ui/design-tokens';
import fonts from '../../ui/fonts';

const Module = styled.div<{ gradient: boolean }>`
  background: ${({ theme, gradient }) => (gradient ? getSectionGradient(theme) : theme.background)};
  background-repeat: no-repeat;
  background-size: cover;
  color: ${({ theme }) => theme.text};
  padding: 0;

  &.is-cover-image {
    .cover-image {
      ${media.max('medium')`
        display: none;
      `};

      ${media.min('medium')`
          & + .image {
            display: none;
          }
      `};
    }
  }
`;

const ContentZone = styled.div`
  display: flex;
  flex-direction: column-reverse;
  padding: 0;
  backdrop-filter: grayscale(100%);  

  ${media.min('medium')`
    height: 100vh;
  `};

  &.reverse {
    flex-direction: column-reverse;
  }

  .imgFullBackground & {
    margin: 0;
    padding: 0;
    flex-direction: column;

    ${media.min('medium')`
      max-width: 50%;
      display: flex;
      align-items: center;
      background: rgba(0, 0, 0, 0.5);
      max-width: 50%;
      margin: 0;

      &.reverse {
        flex-direction: row-reverse;
      }

      .imgMobile {
        display: none;
      }
    `};

    ${media.min('fullwidth')`
      background: rgba(0, 0, 0, 0.5);
      max-width: 50%;
      margin: 0;
    `};

    .text {
    }
  }

  ${media.min('medium')`
    padding: 0;
    flex-direction: row;

    &.reverse {
      flex-direction: row-reverse;
    }
  `};

  ${media.max('fullwidth')`
    max-width: 100%;
  `};

  ${media.min('fullwidth')`
    margin: 0 auto;
    padding: 0;
  `};
`;
const Container = styled.div`
  display: flex;
  flex-direction: column-reverse;
  text-align: center;
  padding: 0;

  ${media.min('medium')`
    flex-direction: row;
    text-align: left;
    display: flex;
    align-items: center;

    .imgFullBackground & {
      max-width: 100%;
      margin: 0;
      padding: 0;
    }

    .shopCta {
      display: none;
    }
  `}

  ${media.max('fullwidth')`
      max-width: 100%;
  `};

  ${media.min('fullwidth')`
    .imgFullBackground & {
      margin: auto;
    }
  `}

  @media (min-width: 1200px) {
    .imgFullBackground & {
        max-width: 100%;
    }
  }
`;

const TextZone = styled.div<{ isShop: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: ${space(4)} ${space(3)};

  .imgFullBackground & {
    background-repeat: no-repeat;
    height: 100%;
  }
  .academy & {
    background: ${colors.neutral[1000]};
  }
  .title {
    ${fonts.titleLG};
    color: ${colors.neutral[100]};
    margin-top: ${space(2)};
    .shop & {
      color: ${colors.neutral[900]};
    }
  }

  .text {
    margin-top: ${space(3)};
    padding: 0px;
    margin-bottom: ${({ isShop }) => (isShop ? `${space(4)}` : 0)};
    color: ${colors.neutral[100]};

    * {
      color: ${colors.neutral[100]};
    }

    .activities & {
      a,
      p {
        color: ${colors.neutral[100]} !important;
      }
    }
    .shop & {
      * {
        ${fonts.bodyMD};
        color: ${colors.neutral[900]};
      }
    }
  }

  .subtitle {
    ${fonts.highlightsMD};

    .activities &,
    .academy & {
      color: ${colors.neutral[100]};
    }
    color: ${colors.neutral[100]} .shop & {
      color: ${colors.neutral[400]};
    }
  }

  .ctaContainer {
    display: ${({ isShop }) => (isShop ? 'none' : 'initial')};
    margin-top: ${space(4)};
    margin-bottom: ${space(4)};

    a {
      background: ${colors.neutral[100]};
      border-radius: 0;
      color: ${colors.neutral[800]};
      border: 0;
      padding: ${space(1.5)} ${space(2.5)};

      &:hover {
        background: ${colors.neutral[200]};
        color: ${colors.primary[600]};
      }

      .shop & {
        border: 2px solid ${colors.neutral[900]};

        &:hover {
          background: ${colors.primary[600]};
          color: ${colors.neutral[100]};
          border: 2px solid ${colors.primary[100]};
        }
      }
    }
  }

  ${media.min('medium')`
    padding: ${space(8)};
    max-width: 50%;

    .imgFullBackground & {
      max-width: 100%;
      background-image: none !important;
    }

    .academy & {
      background: none;
    }

    .title {
      margin-top: ${space(2)};
      ${fonts.titleMD};
    }

    .text {
      margin-top: ${space(2)};
      margin-left: 0;
    }

    .ctaContainer {
      display: initial;
      margin-top: ${space(3)};
      margin-bottom: 0;
    }
  `}

  @media (min-width: 960px) and (max-width: 1200px) {
    padding: 0 4rem;

    .title {
      ${fonts.titleSM};
    }

    .subtitle {
      font-size: 2rem;
    }

    .text {
      p {
        font-size: 1.15rem !important;
      }
    }
  }

  ${media.min('fullwidth')`
    max-width 50%;

    .imgFullBackground & {
      max-width: 100%;
    }
    .contentZone & {
      max-width: 50%;
    }
  `}
`;

const ImageZone = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  .image {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ${media.min('medium')`
    max-width: 50%;

    .image {
      width: 100%;
      height: auto;
      img, picture {
        max-width: 100%;
        width: fit-content;
        height: auto;
        position: relative;
      }
    }

    .image-adjust {
      padding: 4.5rem;
    }
  `}
`;

export { Module, ContentZone, Container, TextZone, ImageZone };
